module.exports = __webpack_public_path__ + "static/media/Desktop_Skills_1.82fbef9f.png";